import React, { useEffect, useState } from "react";
// import Filter from '../../../WelcomeBackMsg/WelcomeBack.jsx';
import { BiPencil } from "react-icons/bi";
import { CiLocationOn, CiMail } from "react-icons/ci";
import { FiServer } from "react-icons/fi";
import { HiOutlineClipboard, HiOutlineUsers } from "react-icons/hi2";
import { PiPhoneCallLight, PiQuestionLight } from "react-icons/pi";

import { Link } from "react-router-dom";
import "./StudentsProfile.css";
import axios from "axios";

const StudentsProfile = () => {
  const [studentsProfileData, setStudentsProfileData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalpage, setTotalPage] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const getData = async () => {
    axios
      .get(`${API_BASE_URL}/admin/students-search?currentPage=${currentPage} &mobile=${searchInput}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        // console.log(response.data?.students);
        const data = response.data?.students;
        setStudentsProfileData(data);
        setTotalPage(response.data?.totalpage);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    const timeId = setTimeout(() => {
      getData();
    }, 1000);

    return () => clearTimeout(timeId);
  }, [searchInput]);

  useEffect(() => {
    getData(); // immediate fetch
  }, [currentPage]);
  return (
    <>
      <div id="student-profile-main">
        <div className="profile-header">
          <h4>Student's Profile</h4>

          <div className="search-box">
            <input
              type="text"
              value={searchInput}
              placeholder="Search student..."
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <span className="search-icon">🔍</span>
          </div>
        </div>

        <div className="student-profile-inner-div">
          {studentsProfileData &&
            [...studentsProfileData]?.reverse()?.map((student, idx) => (
              <div
                className="student-profile-card-container border border-2 p-3"
                key={idx}
              >
                {student?.photo ? (
                  <div className="student-profile-student-image-box">
                    <img
                      src={`${API_BASE_URL}/uploads/${student.photo}`}
                      alt="student-img"
                    />
                  </div>
                ) : (
                  <div className="student-profile-student-image-box">
                    <img
                      src={require("../../../Images/student-profile-img.png")}
                      alt="student-img"
                    />
                  </div>
                )}

                <div className="student-profile-student-details-box">
                  <p className="student-name-b">
                    <b>
                      {student.fullName}
                      {/* <span className="tuition-per-month-fee-amount">
                        <img
                          src={require("../../../Images/rupee-icon.png")}
                          alt=""
                        />
                        2000/m
                        <BiPencil
                          style={{ fontSize: "14px", marginLeft: "5px" }}
                        />
                      </span> */}
                    </b>
                  </p>
                  {/* <div className="stud-profile-main-div">
                    <Link to={"./student-profile-details"}>
                      <p className="student-profile-details">
                        <HiOutlineUsers className="icon-margin" />
                        <b>Profile</b>
                      </p>
                    </Link>
                  </div> */}
                  <p className="student-phone-and-email">
                    <span className="student-contact">
                      <PiPhoneCallLight className="icon-margin" />
                      {student.mobile}
                    </span>
                    <span className="student-email">
                      <CiMail className="icon-margin" />
                      {student.email}
                    </span>
                  </p>
                  <p className="student-address">
                    <CiLocationOn className="icon-margin" /> {student.address} ,{" "}
                    {student.city} , {student.state} - {student.pinCode}
                  </p>
                </div>
              </div>
            ))}
        </div>

        <div className="pagination-conatiner">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Previous
          </button>
          <button disabled={true}>{currentPage}</button>
          <button
            disabled={currentPage === totalpage}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
};

export default StudentsProfile;
